import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function ErrorMessage({ message, className }) {
    if (!message) return null;

    return (
        <div className={cn('text-danger text-xs py-1.5', className)} role="alert" aria-live="assertive">
            {message}
        </div>
    );
}

ErrorMessage.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
};
